'use strict';

export default class{

	/*@ngInject*/
	constructor(tutorID, $http){
		this.$http = $http;
		this.tutorID = tutorID;
		this.rateTypes = ['B', '1', '2'];
		this.loaded = false;
		this.states = ['QLD', 'NSW', 'VIC', 'SA', 'WA', 'TAS', 'NT', 'ACT'];
	}

	$onInit(){
		this.$http.get('/api/tutors/' + this.tutorID).then(res => {
			this.tutor = res.data;
			this.loaded = true;
		})
	}

	edit(callback){
		this.$http.put('/api/tutors/' + this.tutorID, this.tutor).then(res => {
			callback();
		})
	}

}


// WEBPACK FOOTER //
// ./client/app/modals/edit-tutor/edit-tutor.controller.js